import DOMPurify from 'dompurify';

// DOMPurify config against XSS.
const DOMPurifyConfig = {
  FORBID_TAGS: ['script'],
  ALLOWED_TAGS: ['div', 'p', 'span', 'a', 'ul', 'ol', 'li', 'br', 'strong', 'em', 's', 'img'],
  ALLOWED_ATTR: ['href', 'title', 'target', 'class', 'style', 'src', 'alt', 'width', 'height'],
  FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur'],
  ALLOW_DATA_ATTR: false,
  RETURN_DOM: false,
  RETURN_DOM_FRAGMENT: false,
  RETURN_DOM_IMPORT: false,
};

/**
 * Sanitize HTML string to prevent XSS attacks.
 * Removes dangerous tags, attributes, and event handlers while preserving safe HTML formatting.
 *
 * @param data - HTML string to sanitize
 * @returns - Sanitized HTML string
 */
export const sanitize = (data) => {
  return DOMPurify.sanitize(data, DOMPurifyConfig).toString();
};
